import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M15 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M3 12a10 6.5 0 0 1 14 -6.5","key":"svg-2"}],["path",{"d":"M21 12a10 6.5 0 0 1 -14 6.5","key":"svg-3"}]]

const IconZodiacCancer = createReactComponent('outline', 'zodiac-cancer', 'ZodiacCancer', __iconNode);

export default IconZodiacCancer;